import React from 'react';

const PixelIcon = ({ status }) => {
  const label = status === "done" ? "✓" : status === "ongoing" ? "●" : "★";
  const bgColor = status === "done" ? "bg-green-500/80" : 
                  status === "ongoing" ? "bg-yellow-400/80" : 
                  "bg-purple-500/80";
  
  return (
    <span
      aria-hidden
      className={`inline-grid place-items-center h-6 w-6 rounded ${bgColor} ${
        status === "ongoing" ? "animate-pulse" : ""
      }`}
    >
      <span className="text-xs font-black text-white">{label}</span>
    </span>
  );
};

export default PixelIcon;

